module.exports = __webpack_public_path__ + "img/motorway_8x1.31fc5e46.svg";